import moment from 'moment';

export const defaultMenuSelection = dish => {
  return {
    dish,
    dish_id: dish.id,
    menu_dish_id: dish.id,
    quantity: 0,
    notes: ''
  };
};

export const mapMenuSelection = (dish, menu_selections) => {
  const menu_selection = menu_selections.find(
    selection => selection.menu_dish_id === dish.id
  );
  // update the dish just in case
  if (menu_selection) menu_selection.dish = dish;
  return menu_selection ? menu_selection : defaultMenuSelection(dish);
};

export const generateMenuSelections = menu => {
  if (!menu) return [];
  const { courses = [] } = menu;
  return courses
    .reduce((accum, course) => [...accum, ...course.dishes], [])
    .map(dish => defaultMenuSelection(dish));
};

export const populateMenuSelections = (menu, menu_selections) => {
  if (!menu) return [];
  const { courses = [] } = menu;
  return courses
    .reduce((accum, course) => [...accum, ...course.dishes], [])
    .map(dish => mapMenuSelection(dish, menu_selections));
};

/*
 * Determine if menu for a service should be locked based on service's start_time
 */
export const setLockStatus = (start_time) => 
  moment(start_time)
    .subtract(1, 'days')
    .isBefore();

/*
 * Determine if service should be locked from skipping
 */
export const setSkipLockStatus = (start_time) => 
  moment(start_time)
    .subtract(2, 'days')
    .isBefore();




// WEBPACK FOOTER //
// ./src/helpers/menuSelection.js